import { action, computed, makeObservable, observable } from 'mobx'

export interface ContainerMovementInfo {
  containerJourneyId: number
  containerNumber: string
}

export class ContainerMovementDialogStore {
  isOpen = false
  containers: ContainerMovementInfo[] = []

  constructor() {
    makeObservable(this, {
      isOpen: observable,
      containers: observable,

      closeDialog: action,
      openDialog: action,
      reset: action,
      setContainers: action,

      selectedContainer: computed,
    })
  }

  openDialog(containers?: ContainerMovementInfo[]) {
    this.isOpen = true
    this.setContainers(containers)
  }

  closeDialog() {
    this.isOpen = false
    this.reset()
  }

  setContainers(containers?: ContainerMovementInfo[]) {
    this.containers = containers ?? []
  }

  get selectedContainer() {
    return this.containers[0]
  }

  reset() {
    this.setContainers()
  }
}

export const containerMovementDialogStore = new ContainerMovementDialogStore()
